import React from 'react';
import Chip from '@material-ui/core/Chip';

const RegistrationRequestChips = ({ customClasses, variant, registrationResources }) => {
    return (
        <>
            {
                registrationResources.map((resource, index) =>
                    <Chip
                        key={index}
                        size="small"
                        label={resource.destinationCityName}
                        className={customClasses}
                        variant={variant}
                        color="primary"
                    />
                )
            }
        </>
    )
}

export default RegistrationRequestChips;